import APIController from '../core-api-controller';

export const fetchTemplateListApi = (paramsObj = {}, paramsStr = '') => {
  const path = `${APIController.endpointApi}/templates${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const updateTemplateApi = (templateId = '', data = {}) => {
  const path = `${APIController.endpointApi}/templates/${templateId}`;
  return APIController.putCallback(path, data);
};

export const createTemplateApi = (data = {}, type) => {
  const path = `${APIController.endpointApi}/templates?class=${type}`;
  return APIController.postCallback(path, data);
};

export const deleteTemplateApi = (templateId = '', type) => {
  const path = `${APIController.endpointApi}/templates/${templateId}?class=${type}`;
  return APIController.deleteCallback(path);
};

export const fetchTemplateHtmlBodyApi = (templateId = '', type = '') => {
  const path = `${APIController.endpointApi}/templates/${templateId}/fetch_html_body?class=${type}`;
  return APIController.getApiCallback(path, {});
};
